import api from './apiClient';

// Lambda-backed service for the singleton "company" document
const companyService = {
  // Fetch the company object from Lambda/DynamoDB
  async getObjectData() {
    return await api.get('/company');
  },
  // Replace the company object
  async updateObjectData(next) {
    const body = next && typeof next === 'object' ? next : {};
    return await api.put('/company', body);
  },
};

export default companyService;
